import type { DataItem } from '@pn/core/domain/data';
import { useBuildSliceSelector } from '@pn/services/redux/useBuildSliceSelector';
import { isNil } from 'lodash-es';
import { store } from 'src/application/storage/store';
import { formationsOverviewSlice } from './formationsOverviewSlice';

export const useFormationsOverviewStorage = () => {
  const { name, getInitialState } = formationsOverviewSlice;

  const useSliceSelector = useBuildSliceSelector(name, getInitialState());

  return {
    isFetching: useSliceSelector((state) => state.isFetching),
    isError: useSliceSelector((state) => state.isError),
    stats: useSliceSelector((state) => state.stats),
    shouldLoadStats: useSliceSelector((state) => state.shouldLoadStats),
  };
};

export const formationsOverviewActions = () => {
  const { dispatch, getState } = store;
  const { actions, name } = formationsOverviewSlice;

  if (isNil(getState()[name])) {
    throw new Error(`[${name}] reducer has not been injected yet`);
  }

  return {
    receive: (stats: DataItem[]) => dispatch(actions.receive(stats)),
    request: () => dispatch(actions.request()),
    error: () => dispatch(actions.error()),
    reset: () => dispatch(actions.reset()),
  };
};
